import { render, staticRenderFns } from "./phoria.score.table.vue?vue&type=template&id=52d85b6a&scoped=true"
import script from "./phoria.score.table.vue?vue&type=script&lang=js"
export * from "./phoria.score.table.vue?vue&type=script&lang=js"
import style0 from "./phoria.score.table.vue?vue&type=style&index=0&id=52d85b6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d85b6a",
  null
  
)

export default component.exports